import getUsedBlockTemplatesIdsFromElement from './get-used-block-templates-ids-from-element';

export default {
  getUsedBlockTemplatesIdsFromElement,
};
